<template>
	<div class="container-fluid">
		<base-searchHead></base-searchHead>

		<div class="myCompanyBox myCompanyBox1" style="background: unset;margin-bottom: 25px;">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/' }"><img src="../../static/images/home.svg" class="homelogo">
				</el-breadcrumb-item>
				<el-breadcrumb-item :to="{path:'newCenter'}"><span class="bread_text">新闻中心</span></el-breadcrumb-item>
				<!-- <el-breadcrumb-item :to="{path:'newCenter'}"><span class="bread_text">最新动态</span></el-breadcrumb-item> -->
				<el-breadcrumb-item><span class="bread_text">新闻详情</span></el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<div class="myCompanyBox myCompanyBox1">
			<div class="newDetailBox">
				<div class="newDetailBox-text">
					<p class="newDetailBox-title">
						{{newDetail.title}}
					</p>
					<p class="newDetailBox-time">
						{{newDetail.author}} <span>{{newDetail.addTime}}</span>
					</p>
				</div>
				<div class="newDetail-textBox" v-html="newDetail.content">

				</div>
			</div>

		</div>

		<!-- foot -->
		<base-Foot></base-Foot>
		<!-- foot -->
	</div>
</template>

<script>
	// @ is an alias to /src
	// import HelloWorld from '@/components/HelloWorld.vue'
	import baseSearchHead from '@/components/baseHead.vue'
	import axios from "@/utils/request"
	import baseFoot from '@/components/baseFoot.vue'
	export default {
		name: 'newDetail',
		components: {
			'base-searchHead': baseSearchHead,
			'base-Foot': baseFoot,
		},

		data() {
			return {
				newDetail: {}
			};
		},
		methods: {
			getNewDetail(newID) {
				var vm = this
				var data = {
					appData: {
						newID: newID,
						clientType: 1
					},
					version: 2.1,
					sign: "3b0b8438b5c685e7e396f9e7c0394a41",
					time: 1642472216346,
					// token: localStorage.getItem('token'),
				}
				axios.post("Index/getNewDetail", data).then(res => {
					if (res.data.code == 1) {
						vm.newDetail = res.data.data
						document.title = res.data.data.title
						const metaKeywords = document.querySelector('meta[name="keywords"]');
						if (metaKeywords) {
							metaKeywords.setAttribute('content', res.data.data.title);
						} else {
							// 如果不存在，则创建一个新的 meta 标签
							const newMeta = document.createElement('meta');
							newMeta.setAttribute('name', 'keywords');
							newMeta.setAttribute('content', res.data.data.title);
							document.head.appendChild(newMeta);
						}
						const metaDescription = document.querySelector('meta[name="description"]');
						if (metaDescription) {
							metaDescription.setAttribute('content', res.data.data.title);
						} else {
							// 如果不存在，则创建一个新的 meta 标签
							const newMeta1 = document.createElement('meta');
							newMeta1.setAttribute('name', 'description');
							newMeta1.setAttribute('content', res.data.data.title);
							document.head.appendChild(newMeta1);
						}
					} else {
						console.log("error")
						vm.$message({
							type: 'error',
							message: res.data.msg,
							duration: 3000,
							showClose: true
						});
					}
				})
			}
		},
		mounted() {},
		created() {
			if (this.$route.params.id != undefined) {
				this.getNewDetail(this.$route.params.newID)
				console.log(this.$route.params.newID)
			} else {
				this.getNewDetail(this.$route.query.newID)
				console.log(this.$route.query.newID)
			}
		}
	}
</script>

<style scoped>

	
	
	@media screen and (min-width: 769px) {
		.show_m {
			display: none !important;
		}
		
		.myCompanyBox {
			max-width: 1257px;
			min-width: 1257px;
			margin: 0px auto;
		}
		
		.myCompanyBox1 {
			background-color: #fff;
		}
		
		.newDetailBox {
			padding: 25px 40px;
		}
		
		.newDetailBox-text {
			padding-bottom: 20px;
			border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		}
		
		.newDetailBox-title {
			font-size: 20px;
			text-align: center;
			color: #171717;
			font-weight: bold;
		}
		
		.newDetailBox-time {
			font-size: 12px;
			text-align: center;
			color: #9E9E9E;
			margin-top: 20px;
		
		}
		
		.newDetailBox-time span {
			margin-left: 10px;
		}
		
		.newDetail-textBox {
			padding: 30px 60px;
		
		}
		
		.newDetail-textBox img {
			margin: 15px 0;
			max-width: 100%;
			height: auto;
		}
	}
	
	@media screen and (max-width: 768px) {
		.show_pc {
			display: none !important;
		}
		
		.myCompanyBox {
			max-width: unset !important;
			min-width: unset !important;
			margin: 0px auto;
			padding:0px 10px;
		}
		.myCompanyBox1 {
			background-color: #fff;
		}
		
		.newDetailBox {
			padding: 10px 0px;
		}
		
		.newDetailBox-text {
			padding-bottom: 20px;
			border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		}
		
		.newDetailBox-title {
			font-size: 20px;
			text-align: center;
			color: #171717;
			font-weight: bold;
		}
		
		.newDetailBox-time {
			font-size: 12px;
			text-align: center;
			color: #9E9E9E;
			margin-top: 20px;
		
		}
		
		.newDetailBox-time span {
			margin-left: 10px;
		}
		
		.newDetail-textBox {
			padding: 10px 0px;
		
		}
		
		.newDetail-textBox img {
			margin: 15px 0;
			max-width: 100%;
			height: auto;
		}
	}
</style>